/* gallery-pdp.js  desktop PDP enhancements for the Gallery product page.
   1) Hover arrow zones over the main image that page prev/next by clicking the
      adjacent thumbnail (reuses the theme's own gallery switching — no new engine).
   2) Groups the Description + Fit/Materials/Length blocks into Description /
      Size & Fit tabs (the design's .ptabs).
   Scoped to .gpdp; mobile keeps the theme's Swiper (untouched). */
(function () {
  'use strict';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var root = document.querySelector('.product.gpdp');
    if (!root) return;
    buildGalleryNav(root);
    buildTabs(root);
    buildColorSync(root);
    preventVariantScrollJump();
    buildSaleBadgeSync(root);
    buildStickyAtc(root);
    buildMobileThumbs(root);
    trimDiscount(root);
    document.addEventListener('product:variant-change', function () { trimDiscount(root); });
  });

  /* The theme leaves an (empty) discount element in the price line when a variant
     isn't on sale; our styling turns that into a blank red pill. Hide it whenever it
     has no text. Scoping to trimmed text also covers the mirrored sticky-bar copy. */
  function trimDiscount(scope) {
    (scope || document).querySelectorAll('.product__price-displayed-discount').forEach(function (el) {
      el.style.display = el.textContent.trim() ? '' : 'none';
    });
  }

  /* Mobile gallery has only pagination dots — add a real thumbnail strip beneath the
     swiper. Tapping a thumb clicks the matching pagination bullet (the theme's own
     slide control), and swipes reflect back onto the active thumb. */
  function buildMobileThumbs(root) {
    var swiperC = root.querySelector('.product__media-container.below-mobile');
    if (!swiperC) return;
    var imgEls = swiperC.querySelectorAll('.swiper-slide img, .product__media-item img');
    if (imgEls.length < 2) return;
    var strip = document.createElement('div');
    strip.className = 'gpdp-mthumbs';
    if (imgEls.length > 6) strip.classList.add('gpdp-mthumbs--start'); // left-align many photos
    var thumbs = [];
    function setActive(i) { for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('on', j === i); }
    for (var i = 0; i < imgEls.length; i++) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'gpdp-mthumb';
      var im = document.createElement('img'); im.src = imgEls[i].currentSrc || imgEls[i].src; im.alt = '';
      btn.appendChild(im);
      (function (idx) {
        btn.addEventListener('click', function () {
          var bullet = swiperC.querySelectorAll('.swiper-pagination-bullet')[idx];
          if (bullet) bullet.click();
          setActive(idx);
        });
      })(i);
      strip.appendChild(btn);
      thumbs.push(btn);
    }
    swiperC.insertAdjacentElement('afterend', strip);
    setActive(0);
    var pag = swiperC.querySelector('.swiper-pagination');
    if (pag && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var bs = swiperC.querySelectorAll('.swiper-pagination-bullet');
        for (var k = 0; k < bs.length; k++) { if (bs[k].classList.contains('swiper-pagination-bullet-active')) { setActive(k); break; } }
      }).observe(pag, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  /* The compact "Complete the look" teaser under the description scrolls the shopper
     down to the full, shoppable Complete the Look section. Delegated on document so
     it works regardless of when/where the teaser renders. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-gpdp-look-scroll]');
    if (!trigger) return;
    var section = document.querySelector('[data-section-type="gly-look"]');
    if (section) { e.preventDefault(); section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* Floating add-to-cart bar. Appears once the real Add-to-Cart button scrolls out
     of view and mirrors the live title/price. Its button clicks the REAL submit
     button so variant/quantity selection and the theme's cart logic run unchanged —
     no cart code is duplicated here. */
  function buildStickyAtc(root) {
    var realBtn = root.querySelector('.product-form__cart-submit');
    var titleEl = root.querySelector('.product__title');
    if (!realBtn || !titleEl) return;

    var img = root.querySelector('.product__media-item img, .product__media img, .product-thumbnails__item-link img');
    var imgSrc = img ? (img.currentSrc || img.src) : '';

    var bar = document.createElement('div');
    bar.className = 'gpdp-sticky';
    bar.hidden = true;
    bar.innerHTML =
      '<div class="gpdp-sticky__inner">' +
        '<div class="gpdp-sticky__info">' +
          (imgSrc ? '<span class="gpdp-sticky__thumb"><img src="' + imgSrc + '" alt=""></span>' : '') +
          '<span class="gpdp-sticky__meta">' +
            '<span class="gpdp-sticky__title">' + titleEl.textContent.trim() + '</span>' +
            '<span class="gpdp-sticky__price" data-gpdp-sticky-price></span>' +
          '</span>' +
        '</div>' +
        '<button type="button" class="gpdp-sticky__add btn btn--primary" data-gpdp-sticky-add></button>' +
      '</div>';
    document.body.appendChild(bar);

    var priceEl = bar.querySelector('[data-gpdp-sticky-price]');
    var stickyBtn = bar.querySelector('[data-gpdp-sticky-add]');

    function syncPrice() {
      // mirror the whole price line so the compare-at strikethrough + discount badge
      // carry into the bar (desktop and mobile), not just the current price
      var src = root.querySelector('.product__price');
      if (src && priceEl) { priceEl.innerHTML = src.innerHTML; trimDiscount(priceEl); }
    }
    function syncBtn() {
      // mirror the real button's label/disabled state (Add to cart / Sold out / Pre-order…)
      stickyBtn.textContent = (realBtn.textContent || 'Add to cart').trim();
      stickyBtn.disabled = realBtn.disabled;
    }
    syncPrice(); syncBtn();
    document.addEventListener('product:variant-change', function () { syncPrice(); syncBtn(); });

    // Clicking the sticky button just fires the real one (native add-to-cart flow).
    stickyBtn.addEventListener('click', function () { if (!realBtn.disabled) realBtn.click(); });

    // When the bar starts showing: once the shopper has scrolled fully past a
    // reference point. If a Complete the Look section exists, that's the reference
    // (so the sticky bar doesn't compete with that section's own "Add all to bag");
    // otherwise it's the real Add-to-Cart button. A scroll check (vs an observer)
    // stays correct even on fast scrolls or jumps back to the top.
    var ref = document.querySelector('[data-section-type="gly-look"]') || realBtn;
    var ticking = false;
    function checkSticky() {
      ticking = false;
      bar.hidden = ref.getBoundingClientRect().bottom > 0;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(checkSticky); }
    }, { passive: true });
    window.addEventListener('resize', checkSticky, { passive: true });
    checkSticky();
  }

  /* The theme updates the inline price discount on variant change but NOT the sale
     badge over the image, so a non-discounted colour still showed "50% off". Toggle
     the badge to match the actually-selected variant. */
  function buildSaleBadgeSync(root) {
    var badges = root.querySelectorAll('.product-badge--sale');
    if (!badges.length) return;
    function set(onSale) {
      badges.forEach(function (b) { b.hidden = !onSale; b.style.display = onSale ? '' : 'none'; });
    }
    // initial: the server-rendered current variant shows a compare-at price only when on sale
    var comp = root.querySelector('[data-compare-price]');
    set(!!(comp && comp.textContent.trim()));
    document.addEventListener('product:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      set(!!(v && v.compare_at_price && v.compare_at_price > v.price));
    });
  }

  /* The theme re-renders the variant picker and moves focus on every variant
     change, which can make the browser jump/scroll to the variant selector. Pin
     the window scroll position across the change so the page never moves. */
  function preventVariantScrollJump() {
    var y = 0, armedAt = 0;
    var CONTROL = '.product__variants-wrapper, .product__color-swatch, .product__chip, .product__color-swatches, .product__color-chips, .product__option, .select-wrapper';
    function restore() {
      var cur = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (Math.abs(cur - y) > 3) window.scrollTo(0, y);
    }
    // Arm only when the shopper actually presses a variant control, capturing the
    // scroll position at that instant (before any re-render/focus jump).
    function arm(e) {
      if (e.target.closest && e.target.closest(CONTROL)) {
        y = window.pageYOffset || document.documentElement.scrollTop || 0;
        armedAt = Date.now();
      }
    }
    document.addEventListener('pointerdown', arm, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') arm(e); }, true);
    // Only pin scroll for a user-initiated variant change (ignore programmatic/load ones).
    document.addEventListener('product:variant-change', function () {
      if (!armedAt || Date.now() - armedAt > 1500) return;
      restore();
      requestAnimationFrame(function () { restore(); requestAnimationFrame(restore); });
      setTimeout(restore, 90);
      setTimeout(restore, 220);
    });
  }

  /* ---------------- color/variant -> desktop gallery ----------------
     The theme updates only the mobile swiper on variant change (its desktop
     branch is dead because the swiper always exists). Mirror it: when the variant
     changes, switch the desktop gallery to that variant's image and scroll the
     thumbnail rail to it. Uses the theme's own product:variant-change event. */
  function buildColorSync(root) {
    document.addEventListener('product:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.featured_media) return;
      var desk = root.querySelector('.product__media-container.above-mobile');
      if (!desk) return;
      var mediaId = String(v.featured_media.id);
      var thumb = desk.querySelector('.product-thumbnails__item-link[data-thumbnail-id="' + mediaId + '"]');
      // Only act when the image actually changes — never on a same-image (e.g. size) change.
      if (!thumb || thumb.classList.contains('active')) return;
      // Replicate the theme's switchImage by toggling classes directly — do NOT .click()
      // the thumbnail (that focuses the button and makes the browser scroll to it).
      var media = desk.querySelector('.product__media');
      if (media) {
        media.querySelectorAll('.product__media-item').forEach(function (it) {
          it.classList.toggle('hidden', it.getAttribute('data-media-item-id') !== mediaId);
        });
      }
      desk.querySelectorAll('.product-thumbnails__item-link').forEach(function (t) {
        t.classList.toggle('active', t === thumb);
      });
      revealInRail(desk, thumb); // scroll ONLY the rail's own viewport, not the window
    });
  }

  /* Bring the active thumbnail into view inside the rail's scroll container without
     ever scrolling the page/window. */
  function revealInRail(desk, thumb) {
    var vp = desk.querySelector('.product-thumbnails__viewport');
    if (!vp) return;
    var item = thumb.closest('.product-thumbnails__item') || thumb;
    var vr = vp.getBoundingClientRect(), ir = item.getBoundingClientRect();
    if (ir.top < vr.top) vp.scrollTop -= (vr.top - ir.top) + 8;
    else if (ir.bottom > vr.bottom) vp.scrollTop += (ir.bottom - vr.bottom) + 8;
  }

  /* ---------------- hover arrow navigation ---------------- */
  function buildGalleryNav(root) {
    var desktop = root.querySelector('.product__media-container.above-mobile');
    if (!desktop) return;
    var main = desktop.querySelector('.product__media');
    var thumbs = desktop.querySelectorAll('.product-thumbnails__item-link');
    if (!main || thumbs.length < 2) return; // nothing to page through
    if (main.querySelector('.gpdp-gnav')) return;

    var chev = function (dir) {
      var d = dir === 'prev' ? 'M15 18l-6-6 6-6' : 'm9 18 6-6-6-6';
      return '<span class="gpdp-gnav__chev"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg></span>';
    };
    var nav = document.createElement('div');
    nav.className = 'gpdp-gnav';
    nav.innerHTML =
      '<button type="button" class="gpdp-gnav__zone gpdp-gnav__zone--prev" aria-label="Previous image">' + chev('prev') + '</button>' +
      '<button type="button" class="gpdp-gnav__zone gpdp-gnav__zone--next" aria-label="Next image">' + chev('next') + '</button>';
    main.appendChild(nav);

    function items() { return Array.prototype.slice.call(desktop.querySelectorAll('.product-thumbnails__item')); }
    function activeIndex(list) {
      for (var i = 0; i < list.length; i++) { if (list[i].querySelector('.product-thumbnails__item-link.active')) return i; }
      return 0;
    }
    function go(step) {
      var list = items();
      if (list.length < 2) return;
      var i = activeIndex(list);
      var next = (i + step + list.length) % list.length;
      var link = list[next].querySelector('.product-thumbnails__item-link');
      if (link) link.click(); // theme's handler swaps the main image
    }
    nav.querySelector('.gpdp-gnav__zone--prev').addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    nav.querySelector('.gpdp-gnav__zone--next').addEventListener('click', function (e) { e.preventDefault(); go(1); });
  }

  /* ---------------- Description / Size & Fit tabs ----------------
     Wires the deterministic markup rendered by snippets/gallery-product-tabs.liquid
     ([data-gpdp-tabs] with .gpdp-tab[data-tab] buttons + .gpdp-tabs__pane[data-pane]). */
  function buildTabs(root) {
    root.querySelectorAll('[data-gpdp-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('.gpdp-tab');
      var panes = wrap.querySelectorAll('.gpdp-tabs__pane');
      if (tabs.length < 2) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.gpdp-tab');
        if (!btn) return;
        var i = btn.getAttribute('data-tab');
        tabs.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-tab') === i); });
        panes.forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== i; });
      });
    });
  }
})();
